module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_8011.acfe5661.png";